/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Indietro',
      changePassword: 'Cambia password',
      copiedVaultId: 'Copiato!',
      copyVaultID: 'Copia ID Vault',
      create: 'Crea',
      next: 'Avanti',
      notSure: 'Non sono sicuro',
      signUp: 'Iscriviti',
      submit: 'Invia',
      updatePassword: 'Aggiorna la password',
    },
    Errors: {
      createReportFailed: 'Creazione rapporto non riuscita.',
    },
    ReportStatus: {
      CLOSED: 'Chiuso',
      INVESTIGATING: 'Indagine in corso',
      NEW: 'Inviato',
      READ: 'Leggi',
    },
    general: {
      navbar: {
        caseSettings: 'Impostazioni del caso',
        changePassword: 'Cambia password',
        logOut: 'Esci',
        notifications: 'Notifiche',
        notificationsDrawer: {
          appFileScanFailed:
            'Un file non ha superato il controllo di sicurezza',
          appReportMatch: 'Il tuo record GoTogether è stato abbinato',
          appReportReassigned:
            'È stato assegnato un nuovo responsabile del caso',
          case: 'Caso',
          caseAssigned: 'Caso assegnato a te',
          caseImporterJobCompleted: {
            PartialSuccess:
              'Il tuo importo del caso è stato completato con errori',
            failure: 'Il tuo importazione del caso è fallito',
            success: 'Il tuo importo del caso è stato completato con successo',
          },
          caseLinked: 'Caso collegato',
          caseTeamInvite: 'Aggiunto al caso',
          caseUnlinked: 'Caso sconnesso',
          dataSanitisation: 'Dettagli del rapporto aggiornati',
          emptyDescription: 'Torna più tardi per nuove notifiche',
          emptyTitle: 'Sei completamente aggiornato',
          importId: 'ID di importazione:',
          learnMore: 'Scopri di più',
          markAllAsRead: 'Segna tutto come letto',
          newMessage: 'Nuovo messaggio',
          newReport: 'Nuovo rapporto ricevuto',
          permissionRemoved: 'Rimosso dal caso',
          postSSubmissionFile: 'File di prova aggiunto(i)',
          report: 'Rapporto',
          reportAssigned: 'Rapporto assegnato a te',
          reportStatusChange: 'Lo stato del rapporto è cambiato',
          reporterAnonymised: 'I tuoi dettagli sono stati resi anonimi',
          reporterReportSubmitted: {
            subtitle: 'Consigliamo di salvare una copia del tuo rapporto',
            title: 'Rapporto inviato',
          },
          mitigationPlanReminder:
            'Approvazione del piano di mitigazione richiesta',
          staleCase: 'Caso non gestito',
        },
        privacyStatement: 'Dichiarazione sulla privacy',
        reporter: {
          myReports: 'I miei rapporti',
        },
        settings: 'Impostazioni',
        technicalSupport: 'Supporto tecnico',
        title: 'Account',
      },
      time: {
        day: 'Giorno',
        days: 'Giorni',
        hour: 'Ora',
        hours: 'Ore',
        minute: 'Minuto',
        minutes: 'Minuti',
        second: 'Secondo',
        seconds: 'Secondi',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonimo',
        autoTranslate:
          'La funzione di traduzione automatica è disattivata di default.',
        backToMessages: 'Torna ai messaggi',
        caseSettings: 'Impostazioni del caso.',
        changeInProfile:
          'Se desideri modificare questa impostazione, puoi farlo nel tuo profilo',
        deletedByMessage: 'Eliminato da {{author}}',
        deletedMessageLabel: 'Questo messaggio è stato cancellato',
        description:
          "Quando la traduzione automatica è attivata, tutti i messaggi di report verranno\n          tradotti automaticamente utilizzando l'IA in base alla lingua predefinita\n          selezionata sul tuo browser.",
        descriptionSecondHalf:
          'La versione originale di tutti i messaggi è sempre conservata e può essere trovata nella chat.',
        messagePlaceholder: 'Inizia a digitare...',
        messageSettings: 'Impostazioni dei messaggi.',
        originalMessages: 'Originale',
        showMoreBanner: 'Scopri di più sulle traduzioni automatiche',
        titlev2: 'Leggi tutti i messaggi nella tua lingua preferita.',
        translatedMessageLabel: 'Messaggio Tradotto',
        translatedMessages: 'Tradotto',
        understood: 'Compreso',
      },
      Country: {
        description: 'In quale paese ha sede?',
        header: 'In quale paese ha sede?',
        noOptions: 'Nessun paese trovato',
        other: 'Altro',
        placeholder: 'Cerca un paese...',
      },
      CreatePublicReport: {
        createReport: 'Crea nuovo rapporto',
        helpPage: 'Vai alla nostra pagina di aiuto',
        loginToOpr: 'Accesso per tracciare i rapporti',
        or: 'o',
        passwordPlaceholder: 'Immetti password',
        phoneNumberLoginFailed:
          'Accesso non riuscito, numero di telefono/pin incorretto',
        phoneNumberPlaceholder: 'Inserisci il tuo numero di telefono',
        phoneNumberTooltip:
          'Inserisci il numero di telefono che hai utilizzato per contattare VaultTalk',
        pinPlaceholder: 'Inserisci il PIN',
        reportIntroductionParagraph1:
          'Quando segnali un incidente, ti verranno fatte alcune domande per aiutarti a documentare la tua esperienza.',
        reportIntroductionParagraph2:
          "Prima di inviare, hai l'opzione di rimanere anonimo per proteggere la tua privacy.",
        reportIntroductionParagraph3:
          'Dopo aver inviato, puoi accedere in qualsiasi momento per vedere i progressi del tuo rapporto e parlare con un responsabile del caso.',
        reportIssue: 'Segnala un problema',
        usernameLoginFailed:
          'Accesso fallito, nome utente/password non corretti',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              "È richiesto il rapporto con l'azienda",
            reportedCategoryRequired: 'La categoria segnalata è richiesta',
          },
        },
        vaultId: 'ID Vault',
        vaultIdPlaceholder: 'Inserisci la tua Email o ID Vault',
        vaultIdTooltip:
          "Per i rapporti anonimi, l'ID di Vault è alfanumerico. Se il rapporto non era anonimo, l'ID di Vault è il tuo indirizzo email.",
        vaultTalk: 'VaultTalk',
        yourPassword: 'La tua password',
        yourPhoneNumber: 'Il Tuo Numero di Telefono',
        yourPin: 'Il tuo Pin a 6 cifre',
        yourVaultId: 'Il tuo ID Vault',
      },
      CustomHeader: {
        companyLogo: 'Logo aziendale',
        openReporting: 'Apri rapporti',
        userSettings: 'Impostazioni utente',
      },
      Date: {
        approximateDescription:
          "Ricordi la data approssimativa in cui si è verificato l'evento?",
        approximatePlaceholder:
          "Esempio: 6 mesi fa/l'anno scorso/lo scorso novembre",
        cancel: 'annulla',
        clear: 'cancella',
        description: "Ricordi la data in cui si è verificato l'evento?",
        header: 'In quale giorno ha avuto luogo?',
        ok: 'ok',
        placeholder: 'Esempio: 21 giugno 2020',
      },
      Description: {
        whatHappened: 'Che cosa è successo?',
        whatHappenedPlaceholder: 'Usa le tue parole...',
        whatHappenedText: 'Descrivi cosa è successo a parole tue',
      },
      Details: {
        disclaimer:
          'Questi dettagli verranno divulgati con il tuo rapporto. Se desideri rimanere anonimo, assicurati che non contengano informazioni identificative.',
        emailPlaceholder: 'E-mail (opzionale)',
        fullNamePlaceholder: 'Nome (opzionale)',
        header: 'I tuoi dati personali',
        nonAnonSubtitle:
          'Si prega di fornire il proprio nome o un indirizzo email. Se si desidera ricevere notifiche su questo rapporto, aggiungere un indirizzo email appropriato qui sotto.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Nome completo',
        subtitle:
          'Se vuoi ricevere notifiche riguardo a questo rapporto, aggiungi un indirizzo email appropriato qui sotto.',
      },
      Emotion: {
        description: "Come ti ha fatto sentire? Qual è stato l'impatto?",
        header: "Qual è stato l'impatto?",
        placeholder: 'Inizia a digitare...',
      },
      Evidence: {
        addedHeading: 'Aggiunto',
        deletedMessage: 'è stato cancellato',
        deletedStatus: 'Cancellato',
        failedToOpenFileMessage:
          'Impossibile aprire il file. Per favore riprova.',
        fileStatuses: {
          infectedUpload: 'Segnalato dal controllo di sicurezza',
          passedUpload: 'Superato controllo di sicurezza',
          pendingUpload: 'Controllo di sicurezza in corso',
          readyForDownload: 'Pronto per il download',
        },
        mobileErrorMessage:
          'File segnalati: invia un messaggio al tuo responsabile del caso',
        nameHeading: 'Nome',
        statusHeading: 'Stato',
        tableTitle: 'Prova',
        webErrorMessage:
          'File contrassegnati: Se il tuo/i file sono stati contrassegnati, per favore invia un messaggio al gestore del caso.',
      },
      FileUpload: {
        addFiles: 'Aggiungi file',
        addMoreFiles: 'Aggiungi più file',
        confirm: 'Conferma',
        description:
          "Aggiungere file come prova può aiutare a sostenere l'efficienza della risoluzione da parte del tuo gestore di casi. Si prega di considerare il contenuto del file (inclusi i metadati del file) se si desidera rimanere anonimi, e rispettare i diritti degli altri individui e le leggi applicabili.",
        dragDrop: 'Trascina qui i file o',
        errorMessage:
          'Il file/i non sono riusciti a causa di un errore di rete. Clicca qui sotto per inviare un messaggio al tuo case manager per assistenza.',
        fileLimit: 'Limite di dimensione per ogni file: 100MB',
        fileUploadLimitText: 'Puoi caricare solo 10 file',
        header: 'Aggiungi prova',
        helpArticle: 'articolo di aiuto',
        highlighted: 'sfoglia i file',
        information: 'Tipi di file supportati',
        moreInformation:
          'Per ulteriori informazioni, si prega di consultare questo <a>articolo di aiuto</a>',
        postSubmissionErrorMessage:
          "Non abbiamo potuto caricare i tuoi file a causa di un errore di sistema. Seleziona nuovamente 'conferma'.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documenti:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Immagini:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Testo:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Il file è troppo grande',
          invalidFileType: 'Tipo di file non supportato: {{extension}}',
          systemError: 'Errore di sistema',
          tooManyFiles: 'Il numero massimo di file è {{maxFiles}}',
        },
        uploadFiles: 'Carica file',
      },
      Loading: {
        loading:
          'Si prega di attendere mentre inviamo il tuo rapporto a un responsabile del caso...',
        postSubmissionLoading:
          'Si prega di attendere mentre inviamo i vostri file...',
      },
      Location: {
        description: 'Dove è successo?',
        header: 'Dove è successo?',
        placeholder: 'Esempio: In ufficio',
      },
      MessageListBox: {
        messageCaseManager: 'Invia un messaggio al case manager',
        report: 'Rapporto {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Traduzione disabilitata',
        enableTranslationLabelEnabled: 'Traduzione abilitata',
        enableTranslationsDescription:
          'Abilita le traduzioni automatiche e leggi tutti i messaggi del rapporto nella tua lingua preferita. La lingua tradotta si basa sulla lingua selezionata sul tuo dispositivo.',
        enableTranslationsHeader:
          'Abilita la traduzione automatica per i messaggi del rapporto',
        enableTranslationsSubDescriptionv2:
          'Puoi passare tra la lingua tradotta e quella originale in ogni chat.',
        updateTranslationFailed: "L'aggiornamento della traduzione è fallito",
        updateTranslationSuccess:
          "L'impostazione della traduzione è stata aggiornata con successo",
      },
      Password: {
        changePasswordHeader: 'Cambia password',
        createNewPassword: 'Crea una nuova password',
        createPasswordHeader: 'La tua password',
        currentPasswordPlaceholder: 'Immetti la password corrente',
        description:
          'Una password valida deve essere lunga almeno 9 caratteri e includere una lettera maiuscola e un numero',
        enterCurrentPassword: 'Immetti la password corrente',
        forgottenPasswordInstructions:
          "Inserisci il tuo Vault ID alfanumerico (non il tuo indirizzo email) e l'indirizzo email per reimpostare la tua password.",
        newDescription:
          'Crea una password forte per mantenere sicuro il tuo account. Inizia a digitare per vedere le linee guida qui sotto.',
        passwordPlaceholder: 'Crea una password',
        passwordResetRequestedDescription:
          "Se il tuo ID Vault esiste nel nostro sistema, riceverai un'email con le istruzioni per reimpostare la tua password.",
        passwordResetRequestedHeader:
          'Link di reimpostazione password richiesto',
        reenterPlaceholder: 'Immetti di nuovo la password',
        subtitle:
          'Crea una password per inviare questo rapporto e accedervi in futuro',
        yourVaultId: 'Il tuo ID Vault',
        yourVaultIdPlaceholder:
          'Inserisci il tuo ID Vault (ad es. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Stai segnalando una persona specifica o più persone? Potresti nominarle o descriverle?',
        header: 'Persone coinvolte',
        placeholder:
          'Inizia a digitare e usa una virgola per aggiungere più nomi o descrizioni',
      },
      PoweredByVault: 'Con tecnologia {{company}}',
      PrivacyStatement: 'Informativa sulla Privacy del Prodotto',
      PublicMessageList: {
        myMessages: 'I miei messaggi',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Evidenza aggiunta al rapporto esistente',
        backToReportId: 'Torna al rapporto ID: {{reportId}}',
        description:
          "L'aggiunta di file come prove può aiutare a supportare l'efficienza della risoluzione da parte del tuo gestore di casi. Si prega di considerare il contenuto del file (compresi i metadati del file) se si desidera rimanere anonimi, e rispettare i diritti degli altri individui e le leggi applicabili. Per maggiori informazioni, si prega di vedere questo <a>articolo di aiuto</a>",
        header: 'Aggiungi ulteriori prove al rapporto',
        vaultTalkOpenCaseHeader: 'Aggiungi prove alla tua relazione',
      },
      PublicReport: {
        anonymous: 'Anonimo',
        backToReports: 'Torna ai rapporti',
        skipped: 'Ignorato',
      },
      PublicReportCard: {
        addEvidence: 'Aggiungi ulteriori prove',
        messageCaseManager: 'Invia un messaggio al case manager',
        reportId: 'ID rapporto:',
        submitted: 'Inviato',
        vaultTalkClosedCaseCTA: 'Visualizza le prove',
        vaultTalkOpenCaseCTA: 'Aggiungi Prova',
        viewAdditionalEvidence: 'Visualizza ulteriori prove',
        viewReport: 'Visualizza rapporto',
      },
      PublicReportsList: {
        reportingSystem: 'Sistema di segnalazione',
      },
      Question: {
        placeholder: 'Inizia a digitare...',
        question: 'Fornisci dettagli',
        questionText:
          'Condividi con noi la tua preoccupazione, aggiornamento o richiesta.',
      },
      Relationship: {
        header: "Il tuo rapporto con l'organizzazione",
        tellUsAbout: "Parlaci della tua relazione con l'organizzazione.",
      },
      ResponsiveNavMenu: {
        messages: 'I miei messaggi',
        reports: 'I miei rapporti',
      },
      Site: {
        description: 'In quale sede si trova?',
        header: 'In quale sede si trova?',
        noOptions: 'Nessuna sede trovata',
        other: 'Altro',
        placeholder: 'Cerca una sede...',
      },
      SpamPuzzle: {
        dialog: 'Per continuare, risolvi questo puzzle',
      },
      SubmissionTypes: {
        reportIssue: 'Seleziona una categoria',
        whatType: 'Seleziona la categoria che descrive meglio il tuo rapporto',
      },
      SubmitSuccess: {
        category: '<bold>Categoria:</bold> {{category}}',
        country: '<bold>Paese:</bold> {{country}}',
        dateSubmitted: '<bold>Data inviata:</bold> {{date}}',
        recordYourVaultID: "Ricorda queste informazioni per l'accesso",
        successInformation: 'Più informazioni',
        successMessage:
          "Il tuo rapporto è stato inviato ed è pronto per la revisione. Qualsiasi file allegato che richiede attenzione verrà segnalato all'accesso. Accedi qui sotto per visualizzare gli aggiornamenti del rapporto e inviare messaggi al tuo responsabile del caso.",
        successSanitationMessage:
          'Salva una copia per i tuoi registri e tieni al sicuro il tuo Vault-ID: ne avrai bisogno per accedere agli aggiornamenti e per inviare messaggi al tuo gestore del caso.',
        successSanitationTagline:
          'Il tuo rapporto è stato inviato e conservato in modo sicuro.',
        successThankYou: 'Grazie per il tuo rapporto!',
        viewReport: 'Visualizza rapporto',
      },
      Time: {
        approximateDescription:
          "Ricordi l'ora approssimativa in cui si è verificato l'evento?",
        approximatePlaceholder: 'Esempio: di mattina, di pomeriggio',
        description: "Ricordi l'ora in cui si è verificato l'evento?",
        header: 'A che ora si è svolto?',
        invalidTime: "Il formato dell'ora deve essere OO:MM",
      },
      UserSettingsDialog: {
        changePassword: 'Cambia password',
        closeDialog: 'Chiudi finestra di dialogo',
        logout: 'Disconnetti',
        messageSettings: 'Impostazioni Messaggio',
        userSettings: 'Impostazioni utente',
      },
      Witnesses: {
        description:
          'Hai detto a qualcun altro o qualcuno ha visto cosa è successo?',
        header: 'Ci sono testimoni?',
        placeholder: 'Inizia a digitare...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Invia messaggio',
        title: 'Messaggio Caso Manager',
        translationHeader: 'Scopri di più sulle traduzioni automatiche',
      },
      ReportCard: {
        addEvidence: 'Aggiungi prova',
        submissionModeVia: 'via {{modalità di presentazione}}',
        viewEvidence: 'Visualizza le prove',
      },
      ReportList: {
        yourReports: 'I Tuoi Rapporti',
      },
      ReportingActivate: {
        buttonText: 'Continua',
        description:
          "Se la tua organizzazione ti ha registrato per un account, ti invieremo un'email con le istruzioni per completare l'impostazione.",
        emailInput: 'E-mail',
        header: 'Inserisci la tua email di lavoro',
        successAccount:
          "Se la tua organizzazione ti ha registrato per un account, ti invieremo un'email con le istruzioni per completare l'impostazione.",
        successEmail:
          'Se non lo vedi immediatamente, attendi qualche minuto e aggiorna la tua casella di posta elettronica.',
        successHeading: 'Grazie',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Aggiungi prove alla tua relazione',
        descriptionText:
          "Aggiungere file come prova può aiutare a supportare l'efficienza della risoluzione da parte del tuo gestore di casi. Si prega di considerare il contenuto del file (compreso i metadati del file) se si desidera rimanere anonimi e rispettare i diritti degli altri individui e le leggi applicabili. Per ulteriori informazioni, consultare questo <a>articolo di aiuto</a>",
        emptyMessage: 'Nessuna ulteriore prova caricata',
      },
      ReportingChangePassword: {
        back: 'Indietro',
        description:
          'Crea una password forte per mantenere sicuro il tuo account. Inizia a digitare per vedere le linee guida qui sotto.',
        errorToast: 'Impossibile creare la password, token non valido.',
        header: 'Cambia Password',
        incorrectCurrentPassword:
          'La password attuale è sbagliata. Per favore controllala e prova di nuovo.',
        invalidToken: 'Token non valido',
        passwordUpdated: 'Password aggiornata',
        passwordUpdatedDescription:
          'La tua password è stata aggiornata con successo. Grazie per aver intrapreso questo passo per mantenere i tuoi dati sicuri!',
        passwordUsedBefore: 'Riutilizzo della password non consentito',
        passwordUsedBeforeDescription:
          'Per la tua sicurezza, non puoi riutilizzare nessuna delle tue ultime sei password. Scegli una nuova password unica per mantenere il tuo account sicuro e prova di nuovo.',
        toastDescription:
          'La tua password è stata aggiornata con successo. Grazie per aver intrapreso questo passo per mantenere i tuoi dati sicuri!',
        toastMessage: 'Password aggiornata',
        updatePasswordCTA: 'Aggiorna la password',
      },
      ReportingConnect: {
        cancelButton: 'Annulla',
        connectButton: 'Collegati',
        disclaimer:
          "Collegare il tuo account Slack con il tuo account Vault assicura una connessione sicura e privata. <br /><br />Collegandoti, puoi segnalare un comportamento scorretto o fare una domanda direttamente all'interno di Slack. Avrai sempre l'opzione di segnalare in modo anonimo dopo esserti collegato. La tua privacy e la tua sicurezza sono le nostre priorità principali.",
        heading:
          'Vault Platform sta richiedendo il permesso di accedere al tuo account Slack {{organisationName}}',
        listHeading: 'Cosa sarà in grado di fare Vault?',
        permissionIdentity: {
          extraInfo:
            "Vault avrà la capacità di visualizzare l'identità del tuo utente Slack",
          heading: "Visualizza le informazioni sull'identità di un utente",
        },
        permissionNotifications: {
          extraInfo:
            'Vault sarà in grado di inviarti notifiche sul tuo account Slack, riguardanti eventuali aggiornamenti a un rapporto o a una domanda inviata.',
          heading: 'Invia notifiche',
        },
        permissionOverview: {
          extraInfo:
            'Vault mostrerà una panoramica di tutte le sottomissioni nella homepage',
          heading: 'Panoramica delle sottomissioni',
        },
        permissionSubmitReport: {
          extraInfo:
            'Questo concederà a Vault il permesso di inviare un rapporto o fare una domanda, direttamente alla tua organizzazione, da Slack.',
          heading: 'Invia un rapporto o una domanda per tuo conto',
        },
        successfulConnectionDescription:
          'Il tuo account Vault e il tuo account Slack sono ora collegati. Ora puoi chiudere questa scheda e tornare a Slack.',
        successfulConnectionHeading: 'Connesso con successo',
        unsuccessfulConnectionDescription:
          'Qualcosa è andato storto. Si prega di chiudere questa scheda e tornare a Slack per riprovare.',
        unsuccessfulConnectionHeading: 'Connessione fallita',
      },
      ReportingForgotPassword: {
        description:
          "Inserisci l'indirizzo email associato al tuo account e ti invieremo un link per reimpostare la tua password.",
        heading: 'Password dimenticata',
        invalidTokenError: 'Impossibile creare la password, token non valido.',
        passwordReuseError: 'Riutilizzo della password non consentito',
        passwordReuseErrorDescription:
          'Per la tua sicurezza, non puoi riutilizzare nessuna delle tue ultime sei password. Scegli una nuova password unica per mantenere sicuro il tuo account e riprova.',
        sendLink: 'Invia link di reset',
        sendLinkFailure: 'Qualcosa è andato storto',
        sendLinkFailureDescription:
          'Torna al <a>Reporter Hub</a> e prova di nuovo. Se il problema persiste, contattaci a <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link per il reset della password inviato',
        sendLinkSuccessDescription:
          'Abbiamo inviato un link per reimpostare la password a {{email}}',
        updatePasswordSuccess: 'Password aggiornata',
        updatePasswordSuccessDescription:
          'La tua password è stata aggiornata con successo. Grazie per aver compiuto questo passo per mantenere sicuri i tuoi dati!',
      },
      ReportingLogin: {
        accountFrozen: "L'account è congelato",
        accountLocked:
          "L'accesso è stato tentato troppe volte in modo errato. L'account è bloccato per un massimo di 1 ora. Non è possibile reimpostare la password durante questo periodo.",
        accountLockedPermanently:
          "Il tuo account è stato bloccato. Usa il reset della password per riguadagnare l'accesso o contatta l'amministratore del sistema per ulteriore aiuto.",
        createAccountCTA: 'Registrati per un account',
        currentPassword: 'Password attuale',
        emailLabel: 'La tua Email',
        forgotPassword: 'Hai dimenticato la tua password?',
        loginButton: 'Accesso',
        newPasswordPlaceholder: 'Nuova password',
        passwordFailMessage:
          "Torna all'app Vault in Slack e prova di nuovo. Se il problema persiste, contattaci a techsupport@vaultplatform.com",
        passwordFailTitle: 'Qualcosa è andato storto',
        passwordLabel: 'La tua password',
        passwordPlaceholder: 'Inserisci la tua password',
        passwordResetRequired: 'Richiesta di reimpostazione della password',
        passwordSuccessfullySetMessage:
          "Torna all'app Vault in Slack e autenticati con la tua nuova password per continuare da dove avevi lasciato.",
        passwordSuccessfullySetTitle: 'Password impostata con successo',
        reenterPlaceholder: 'Re-inserisci la password',
        title: 'Reporter Hub',
        tooltip:
          'Se non hai mai impostato una password per l\'app Vault, segui qui per iniziare. Se hai dimenticato la tua password, usa il link "Password dimenticata" qui sotto.',
        usernameLoginFailed:
          'Accesso non riuscito, nome utente o password errati',
      },
      ReportingReset: {
        failureDescription:
          "Torna all'app Vault in Slack e prova di nuovo. Se il problema persiste, contattaci a <mailto>techsupport@vaultplatform.com</mailto>",
        failureHeading: 'Qualcosa è andato storto',
        successDescription:
          "Torna all'app Vault in Slack e autenticati con la tua nuova password per continuare da dove hai lasciato.",
        successHeading: 'Password impostata con successo',
      },
      noReports: {
        description:
          'Tutti i rapporti inviati verranno mostrati qui. Scopri di più sui modi in cui sei in grado di inviare un rapporto in',
        descriptionHelpArticle: 'questo articolo di aiuto',
        errorDescription:
          'Stiamo riscontrando difficoltà nel caricare i tuoi rapporti. Per favore prova a ricaricare la pagina.',
        errorDescriptionSecondary:
          'Se ciò non funziona, ti preghiamo di contattarci a',
        errorTitle: '⚠️ Oops, qualcosa è andato storto',
        title: 'Non hai ancora rapporti',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Abilita le traduzioni automatiche e leggi tutti i messaggi dei report nella tua lingua preferita. La lingua tradotta si basa sulla lingua selezionata sul tuo dispositivo.',
          autoTranslationDescription2:
            'È possibile passare tra la lingua tradotta e quella originale in ogni chat.',
          autoTranslationTitle:
            'Abilita la traduzione automatica per i messaggi di report',
          header: 'Impostazioni dei Messaggi',
          subHeader: 'Configura come vengono visualizzati i messaggi',
        },
        notificationSettings: {
          emailDescription:
            'Ricevi notifiche email per aggiornamenti importanti ai tuoi rapporti',
          emailTitle: 'Notifiche Email',
          header: 'Impostazioni delle Notifiche',
          subHeader: 'Configura come ricevi le notifiche',
        },
        title: 'Impostazioni',
        updatedSettingsFailure: 'Impossibile aggiornare le tue impostazioni',
        updatedSettingsSuccess: 'Impostazioni aggiornate con successo',
      },
    },
    validators: {
      passwordLength: 'La password deve contenere almeno 9 caratteri',
      passwordLowercase:
        'La password deve contenere almeno 1 lettera minuscola',
      passwordMissMatch:
        'I campi della password e di conferma devono corrispondere.',
      passwordNumeric: 'La password deve contenere almeno 1 numero',
      passwordUppercase:
        'La password deve contenere almeno 1 lettera maiuscola',
    },
    validatorsNew: {
      passwordLength: 'Tra 10 e 30 caratteri',
      passwordLowercase: 'Almeno una lettera minuscola',
      passwordMissMatch: 'Le password non corrispondono',
      passwordNumeric: 'Almeno un numero',
      passwordSpecialCharacter: 'Almeno un carattere speciale',
      passwordUppercase: 'Almeno una lettera maiuscola',
    },
  },
};

export default translations;
